import { Select } from '@src/controls';
import { withFormItem } from '@src/decorators';
import { FormattedMessage } from '@src/i18n';
import { getFieldArrayError } from '@src/utils/forms';
import { Field, FieldProps, FormikProps } from 'formik';
import * as React from 'react';
import { stylesheet } from 'typestyle';
import { array, string } from 'yup';
import { RuleAddingValues } from '../rule-adding-container';

const SelectItem = withFormItem(Select);

interface Props {
  name: string;
  errors: FormikProps<RuleAddingValues>['errors'];
  touched: FormikProps<RuleAddingValues>['touched'];
  setFieldValue: FormikProps<RuleAddingValues>['setFieldValue'];
}

const hasVouchersValidate = async (value: string) => {
  try {
    await array()
      .min(1, 'Provide at least 1 voucher code')
      .of(string().matches(/^[^\s^'"]+$/, 'Vouchers should not contain spaces or apostrophes'))
      .validate(value);
  } catch (err) {
    return err;
  }
};

export const HasVouchers: React.FunctionComponent<Props> = ({
  name,
  errors,
  touched,
  setFieldValue,
}) => {
  return (
    <div className={styles.wrapper}>
      <Field name={`${name}.values`} validate={hasVouchersValidate}>
        {({ field }: FieldProps<string[]>) => (
          <SelectItem
            label={<FormattedMessage id="HAS_VOUCHERS_LABEL" />}
            className={styles.select}
            options={[]}
            mode="tags"
            {...field}
            onChange={values => {
              setFieldValue(`${name}.values`, values);
            }}
            placeholder="-"
            error={getFieldArrayError(touched, errors, `${name}.values`)}
          />
        )}
      </Field>
    </div>
  );
};

const styles = stylesheet({
  wrapper: {
    padding: '5px 0',
    $nest: {
      '.ant-row': {
        display: 'flex',
        marginBottom: 0,
      },
      '.ant-form-explain': {
        width: '200px',
      },
    },
  },
  select: {
    width: '195px!important',
  },
  label: {
    paddingRight: '10px',
    whiteSpace: 'nowrap',
  },
});
